import { render, staticRenderFns } from "./EndMarker.vue?vue&type=template&id=2b5ea9a8&scoped=true&lang=html&"
var script = {}
import style0 from "./EndMarker.vue?vue&type=style&index=0&id=2b5ea9a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5ea9a8",
  null
  
)

export default component.exports